// extracted by mini-css-extract-plugin
export default {"bgGray":"Cart_bgGray__NmyMN"};